import {
  Collapse,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

import { RHFRadioSingle } from "@app/components";
import { Strings } from "@app/constants";
import { useState } from "react";
import { Icon } from "@iconify/react";

import { KmDrivenFiltersProps } from "../../types";

const KmDrivenFilter = ({ kmsDriven }: KmDrivenFiltersProps) => {
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(true);

  return (
    <Stack sx={{ py: 1 }}>
      <Stack
        flexDirection={"row"}
        justifyContent={"space-between"}
        onClick={() => setDrawerOpen(!drawerOpen)}
      >
        <Typography variant="subtitle1">{Strings.filters.kmDriven}</Typography>
        <IconButton size="small">
          {drawerOpen ? (
            <Icon icon="mdi:chevron-up" width={20} height={20} />
          ) : (
            <Icon icon="mdi:chevron-down" width={20} height={20} />
          )}
        </IconButton>
      </Stack>
      <Collapse in={drawerOpen}>
        {kmsDriven?.map((km: any) => (
          <RHFRadioSingle
            name="kmDriven"
            key={km.value}
            value={km.value}
            label={km.label}
            sx={{ "&.Mui-checked": { color: theme.palette.primary.main } }}
          />
        ))}
      </Collapse>
    </Stack>
  );
};

export { KmDrivenFilter };
